export default "__VITE_ASSET__jb_HaWRR__"